<template>
  <div class="motivos-reservas-perdidas">
    <SidebarLayout2 :breadcrumb="breadcrumb" :pageTitle="pageTitle">
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading> Ações da página </Heading>
          <!-- CADASTRAR -->
          <Button
            :hasIcon="true"
            :link="'/motivos-de-reservas-perdidas/create'"
            element="router-link"
            class="page-actions--button"
          >
            Cadastrar motivo
          </Button>
        </SidebarBlock>
      </template>

      <!-- CONTEÚDO -->
      <template #content>
        <div class="filters">
          <SearchInput
            v-model="searchTerm"
            class="filters--search_width"
            @keypress.enter="filterByText"
            @selectItem="searchSelectedItemHandler"
          />
          <!-- FILTROS -->
          <div class="dropdowns-filters">
            <!-- STATUS -->
            <FilterDropdown
              v-model="statusFilterValue"
              :options="statusFilterOptions"
            ></FilterDropdown>
          </div>
        </div>

        <!-- TABELA -->
        <Datatable
          :cols="gridColumns"
          :rows="gridData"
          :filterKey="filterKey"
          :colsMinWidths="colsWidths"
          :noFrames="true"
          :selectableRow="false"
          :sortable="false"
          :searchableColumns="['descricao']"
          :isLoading="isLoadingTableContent"
          class="datatable"
          ref="datatable"
          notFoundMessage="Não há motivos de reservas perdidas correspondentes com a busca."
        >
          <template v-slot:ativo="{ col }">
            <span v-if="col">Ativo</span>
            <span v-else>Inativo</span>
          </template>

          <template v-slot:acoes="slotProps">
            <Dropdown class="datatable-actions" position="bottom-end">
              <template #button-content>
                <Icon icon="dots" />
              </template>

              <DropdownItem
                :id="slotProps.rowDataObj.codigo"
                :to="
                  `/motivos-reservas-perdidas/editar/${slotProps.rowDataObj.codigo}`
                "
                >Editar</DropdownItem
              >
              <DropdownItem
                v-if="slotProps.rowDataObj.ativo"
                :id="slotProps.rowDataObj.codigo"
                element="button"
                class="danger-color"
                @click.stop.prevent="
                  inactiveReason(slotProps.rowDataObj.codigo)
                "
              >
                Inativar
              </DropdownItem>
            </Dropdown>
          </template>
        </Datatable>
      </template>
    </SidebarLayout2>

    <AlertModal
      v-model="showAlertModal"
      text="Para reativar o motivo selecionado, é necessário editá-lo. Deseja continuar?"
      @alert-modal-confirm="inactiveReasons"
      @alert-modal-cancel="cancelInactiveReasons"
    />
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import SidebarLayout2 from '@/layouts/SidebarLayout2'
import Heading from '@/components/_base/elements/Heading'
import Button from '@/components/_base/elements/Button'
import SearchInput from '@/components/_base/elements/SearchInput'
import FilterDropdown from '@/components/_base/patterns/FilterDropdown'
import Datatable from '@/components/_base/patterns/DataTable'
import SidebarBlock from '@/components/_base/patterns/SidebarBlock'
import AlertModal from '@/components/_base/patterns/AlertModal'
import Dropdown from '@/components/_base/patterns/Dropdown'
import DropdownItem from '@/components/_base/patterns/DropdownItem'

export default {
  name: 'MotivosDeReservasPerdidas',
  components: {
    SidebarLayout2,
    SearchInput,
    FilterDropdown,
    Datatable,
    Button,
    Heading,
    SidebarBlock,
    AlertModal,
    Dropdown,
    DropdownItem
  },
  data() {
    return {
      showAlertModal: false,
      isLoadingTableContent: true,
      isSingleReason: false,
      singleReason: null,
      breadcrumb: [
        {
          label: 'Configurações'
        },
        {
          label: 'Motivos de reservas perdidas',
          url: '/configuracoes/motivos-de-reservas-perdidas',
          isSpa: true /** Se deve ser um link para o site novo ou antigo */
        }
      ],
      pageTitle: 'Motivos de reservas perdidas',
      searchTerm: '',
      searchTermSelected: '',
      statusFilterOptions: [
        {
          label: 'Ativos',
          value: 1,
          checked: true
        },
        {
          label: 'Inativos',
          value: 0,
          checked: false
        },
        {
          label: 'Todos',
          value: 2,
          checked: false
        }
      ],
      statusFilterValue: {
        label: 'Ativos',
        value: 1,
        checked: true
      },
      ratesFilterValue: [],
      ratesFilterOptions: [],
      gridData: [],
      colsWidths: {
        ativo: '50%'
      } /** Objeto com os tamanhos mínimos de cada coluna */,
      gridColumns: [
        /** Colunas do grid */
        { name: 'descricao', alias: 'Reservas perdidas' },
        { name: 'ativo', alias: 'Status' },
        { name: 'acoes', alias: '' }
      ]
    }
  },
  computed: {
    filterKey() {
      if (this.searchTerm.trim() !== '') return this.searchTermSelected

      return ''
    },
    filterValues() {
      return {
        status: this.statusFilterValue.value,
        rates: this.ratesFilterValue.map((item) => item.value).join(',')
      }
    }
  },
  watch: {
    searchTerm(newValue) {
      if (newValue === '') {
        this.searchTermSelected = newValue
        this.filterReasons()
      }
    },
    filterValues: {
      handler: debounce(function(newVal, oldVal) {
        if (newVal.status !== oldVal.status || newVal.rates !== oldVal.rates) {
          this.filterReasons()
        }
      }, 1000)
    }
  },
  created() {
    this.filterReasons()
  },
  mounted() {
    /** Cria um atributo não reativo */
    this.datatableHead = this.$refs['datatable'].$el.querySelector('.thead')
    /** Adiciona a escuta do evento de scroll */
    document.addEventListener('scroll', this.scrollHandler)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.scrollHandler)
  },
  methods: {
    searchSelectedItemHandler(value) {
      this.$router.push({
        path: value.item.link
      })
    },
    inactiveReason(codigo) {
      this.showAlertModal = true
      this.isSingleReason = true
      this.singleReason = [codigo]
    },
    cancelInactiveReasons() {
      this.isSingleReason = false
      this.singleReason = null
    },
    inactiveReasons() {
      this.showAlertModal = false

      this.$reasonsLostReservation
        .inactiveReason(this.singleReason)
        .then((response) => {
          if (response.status === 200) {
            this.$bus.$emit('show-alert-chip', {
              message: 'Motivo de reserva perdida inativada com sucesso'
            })
          }
          this.filterReasons()
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.response.data[0].message
          })
        })

      this.isSingleReason = false
      this.singleReason = null
    },
    filterReasons() {
      const filterObj = {}

      this.isLoadingTableContent = true

      if (this.statusFilterValue.value !== 2) {
        filterObj.ativo = this.statusFilterValue.value > 0
      }

      this.$reasonsLostReservation
        .filterReasons(filterObj)
        .then((response) => {
          this.gridData = this.gridData = this.standardizeReasonData(response)

          this.isLoadingTableContent = false
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.response.data[0].message
          })
        })
    },
    standardizeReasonData(response) {
      return response.data.map((item) => {
        const obj = {
          data: item
        }
        return obj
      })
    },
    /** Filtra ao inserir um texto na busca */
    filterByText($event) {
      this.searchTermSelected = $event.target.value
      this.filterReasons()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}
.motivos-reservas-perdidas {
  .info-panel {
    &--main-text {
      width: 100%;
      margin-bottom: 10px;
      line-height: 1;
      font-size: font-size('size-xx-large');
      font-weight: font-weight('weight-medium');

      &__smaller {
        font-size: font-size('size-large');
      }
    }

    &--aux-text {
      margin-bottom: 10px;
      font-size: font-size('size-large');
      font-weight: font-weight('weight-light');
    }
  }

  .page-actions {
    &--button {
      width: 100%;

      & + .page-actions--button {
        margin-top: 10px;
      }
    }
  }
}
/**
* Espacamento padrao
* Ref: https://www.figma.com/file/9AFe6i7bVhMup1bYeppCU7/Tarifas?node-id=0%3A1
*/
.filters {
  padding: {
    bottom: 30px;
  }

  &--search_width {
    width: 214px;
  }

  .dropdowns-filters {
    margin-top: 16px;
  }
}
/**
* Espacamento padrao
* Ref: https://www.figma.com/file/9AFe6i7bVhMup1bYeppCU7/Tarifas?node-id=0%3A1
*/
.datatable {
  max-height: initial;
  overflow: initial;
  ::v-deep {
    .thead {
      top: 50px;

      &:before,
      &:after {
        content: '';
        width: 50px;
        height: 100%;
        position: absolute;
        top: 0;
        background-color: $white;
        right: 100%;
      }

      &::after {
        right: initial;
        left: 100%;
      }
    }
    .dropdown {
      &-item {
        &:hover,
        &:active {
          background-color: $gray-lightest;
        }
      }
      .danger-color {
        &.dropdown-item {
          color: $red-2;
        }
      }

      &--trigger-button {
        color: $gray-mid;
      }
      &--options {
        min-width: 100px;
      }
    }

    &--quantity-column__danger-color {
      color: $red-2;
    }
  }
}
</style>
